import { AlpineData } from "@/js/interfaces/Components/alpinejs/Tooltip";
import { createAlpineComponent } from "@nolikein/typed-alpinejs";
import is from "@/app/support/is";

/* Generated from the "artisan make:alpine" command */
export default {
    name: 'Tooltip',
    component: (
        // Component parameters...
        messageParameter: string | (() => string),
    ) => createAlpineComponent<AlpineData>({
        // Component properties ...
        show: false,
        message: '',

        /**
         * Initialize the component
         */
        init() {
            this.message = this.getMessage();
        },

        getMessage(): string {
            let data: string = '';

            // We retrieve the current messageParameter value
            if (null !== messageParameter && undefined !== messageParameter) {
                // It can have 2 types : string or function returning a string
                if (is.string(messageParameter)) {
                    data = messageParameter;
                } else if (is.function(messageParameter)) {
                    const result = messageParameter();
                    if (null !== result && undefined !== result) {
                        data = result;
                    }
                }
            }

            return data;
        },

        isMessageEmpty(): boolean {
            return 0 === this.message.length;
        },
    }),
};
